import { createSlice } from "@reduxjs/toolkit";
import { extendSliceWithExcelTable } from "slices/excelTable/utils";

export const initialState = {
  dictionaryList: [],
  edit: {
    editDictionary: null,
    tableSettings: {
      isEditMode: false,
      selectedRowIndex: 0,
      wildcardPopup: {
        displayed: false,
        term: null,
      },
    },
  },
};

export const dictionarySlice = createSlice({
  name: "dictionary",
  initialState,

  reducers: {
    getDictionaries: (state, action) => {
      state.dictionaryList = action.payload || [];
    },
    setDictionary: (state, action) => {
      state.edit.editDictionary = action.payload;
    },
    setModeToEdit: (state) => {
      state.edit.tableSettings.isEditMode = true;
    },
    setModeToView: (state) => {
      state.edit.tableSettings.isEditMode = false;
    },
    setSelectedRowIndex: (state, action) => {
      state.edit.tableSettings.selectedRowIndex =
        action.payload.rowIndex || action.payload;
    },
    displayWildcardPopup: (state, action) => {
      state.edit.tableSettings.wildcardPopup = {
        displayed: action.payload.displayed,
        term: action.payload.term,
      };
    },
    resetEditMode: (state) => {
      state.edit.tableSettings.isEditMode = false;
      state.edit.tableSettings.selectedRowIndex = 0;
    },
    setLocked: (state, action) => {
      state.edit.editDictionary.locked = action.payload;
    },
    setDictionaryDescription: (state, { payload }) => {
      state.edit.editDictionary.description = payload || "";
    },
    setDictionaryTypes: (state, { payload }) => {
      state.edit.editDictionary.dictionaryTypes = payload || [];
    },
    setDictionaryName: (state, { payload }) => {
      state.edit.editDictionary.name = payload;
    },
    ...extendSliceWithExcelTable({
      rootPath: ["edit", "editDictionary", "categories"],
      actionNames: {
        addChildByPath: "addTermByPath",
        updateAllItems: "updateCategories",
        updateItemByPath: "updateDictionaryItemByPath",
        removeItemByPath: "removeDictionaryItemByPath",
      },
    }),
  },
});

export const {
  getDictionaries,
  setDictionary,
  setModeToEdit,
  setModeToView,
  setSelectedRowIndex,
  setSelectedEntry,
  displayWildcardPopup,
  setLocked,
  resetEditMode,
  setDictionaryDescription,
  setDictionaryTypes,
  setDictionaryName,
  updateCategories,
  updateDictionaryItemByPath,
  removeDictionaryItemByPath,
  addTermByPath,
  addCategoryByIndex,
} = dictionarySlice.actions;

export default dictionarySlice.reducer;
